import { ItemQuantitiesById } from './types';

export function getListOfCartItemIds(itemQuantitiesById: ItemQuantitiesById): number[] {
  return Object.entries(itemQuantitiesById).reduce(
    (allItemIds, [itemId, itemQuantity]) => [...allItemIds, ...Array(itemQuantity).fill(+itemId)],
    [],
  );
}

export function displayAsPrice(value: number): string {
  const price = (value / 100).toString().replace('.', ',');

  return `${price} €`;
}
